export default __webpack_public_path__ + "static/media/three_green.7c4a2113.svg";